import { render } from "./SortListCard.vue?vue&type=template&id=4aa4835d&scoped=true"
import script from "./SortListCard.vue?vue&type=script&lang=js"
export * from "./SortListCard.vue?vue&type=script&lang=js"

import "./SortListCard.vue?vue&type=style&index=0&id=4aa4835d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa4835d"]])

export default __exports__